import { LocalFind, LocalInsert } from '@weblite/persist'
import { dateWithOffset } from '$logic/client-device/time-offset.service'

const LAST_PREMIUM_FEATURES_REQUEST_TIME_KEY =
  'lastPremiumFeaturesRequestTimeKey'

export const setLastPremiumFeaturesRequestTime = () =>
  LocalInsert(LAST_PREMIUM_FEATURES_REQUEST_TIME_KEY, dateWithOffset())

export const getLastPremiumFeaturesRequestTime = () =>
  LocalFind(LAST_PREMIUM_FEATURES_REQUEST_TIME_KEY)
